"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logger = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Logger = /*#__PURE__*/function () {
  function Logger() {
    _classCallCheck(this, Logger);
  }

  _createClass(Logger, null, [{
    key: "log",
    value: function log(type, name, duration) {
      console.log('Performance:', {
        duration: "".concat(duration, "ms"),
        name: name,
        type: type
      });
    }
  }]);

  return Logger;
}();

exports.Logger = Logger;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9Mb2dnZXIudHMiXSwibmFtZXMiOlsiTG9nZ2VyIiwidHlwZSIsIm5hbWUiLCJkdXJhdGlvbiIsImNvbnNvbGUiLCJsb2ciXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7SUFBYUEsTTs7Ozs7Ozt3QkFDQUMsSSxFQUFjQyxJLEVBQWNDLFEsRUFBa0I7QUFDdkRDLE1BQUFBLE9BQU8sQ0FBQ0MsR0FBUixDQUFZLGNBQVosRUFBNEI7QUFBQ0YsUUFBQUEsUUFBUSxZQUFLQSxRQUFMLE9BQVQ7QUFBNEJELFFBQUFBLElBQUksRUFBSkEsSUFBNUI7QUFBa0NELFFBQUFBLElBQUksRUFBSkE7QUFBbEMsT0FBNUI7QUFDRCIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjbGFzcyBMb2dnZXIge1xuICBzdGF0aWMgbG9nKHR5cGU6IHN0cmluZywgbmFtZTogc3RyaW5nLCBkdXJhdGlvbjogbnVtYmVyKSB7XG4gICAgY29uc29sZS5sb2coJ1BlcmZvcm1hbmNlOicsIHtkdXJhdGlvbjogYCR7ZHVyYXRpb259bXNgLCBuYW1lLCB0eXBlfSk7XG4gIH1cbn1cbiJdfQ==